import Vue from 'vue'
import Vuex from 'vuex'
import search from './modules/search'
import user from './modules/user'
import ui from './modules/ui'
import status from './modules/status'
import tracking from './modules/tracking'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production';
export default new Vuex.Store({
  modules: {
    search,
    user,
    status,
    ui,
    tracking,
  },
  strict: debug,
})
